import { useCallback, useEffect, useMemo, useState } from 'react';
import api from '../api';

/**
 * Zones d'un serveur (liste personnalisée par l'admin, sinon liste par défaut).
 * Renvoie { zones, availableZones, loading, reload } :
 * - zones : toutes les zones [{ zone, donjon, bda }]
 * - availableZones : zones ouvertes aux membres (hors zones privatisées BDA)
 */
const useServerZones = (serverId) => {
    const [zones, setZones] = useState([]);
    const [loading, setLoading] = useState(true);

    const reload = useCallback(() => {
        if (!serverId) return Promise.resolve();
        setLoading(true);
        return api.get(`/zones/${serverId}`)
            .then(res => setZones(Array.isArray(res.data?.zones) ? res.data.zones : []))
            .catch(err => console.error('Erreur chargement des zones :', err))
            .finally(() => setLoading(false));
    }, [serverId]);

    useEffect(() => { reload(); }, [reload]);

    const availableZones = useMemo(() => zones.filter(z => !z.bda), [zones]);

    return { zones, availableZones, loading, reload };
};

export default useServerZones;
